module.exports = __webpack_public_path__ + "images/FUSA_icons/056-new.84675a63b3ca27f96cda1d6464242bf6.svg";